import axiosClient from "./axiosClient";

export const technicalDocumentsApi = {
    // 技術資料
    getTechnicalDocuments: ({ category, name }: { category?: any; name?: string } = {}) => {
        const url = `api/search-document?category=${category || ""}&name=${name || ""}`;
        return axiosClient.get(url);
    },
    // 個人の通知一覧・個人の通知画面表示用
    getBoxDocumentsPage: (page: any) => {
        const url = `/api/get-list-box-document?page=${page}&limit=10`;
        return axiosClient.get(url);
    },
    // 個人の通知一覧・プロフィール画面表示用
    getBoxDocumentsProfile: () => {
        const url = `/api/get-list-box-document`;
        return axiosClient.get(url);
    },
    // 個人の通知削除
    deleteBoxDocuments: (body: any) => {
        const url = `/api/delete-box-document`;
        return axiosClient.post(url, body);
    },
    // 個人の通知既読
    readBoxDocuments: (body: any) => {
        const url = `/api/read-box-document`;
        return axiosClient.post(url, body);
    },
};
